module.exports = __webpack_public_path__ + "img/pending.78aa8599.svg";